import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_fsa_hsa_payment_method~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fsa_hsa_payment_method/activity-female-tai-chi-walking-v2'
					),
			},
		},
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fsa_hsa_payment_method~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fsa_hsa_payment_method/female'
					),
			},
		},
	},
]

export default config
